import { render, staticRenderFns } from "./VoiceMails.vue?vue&type=template&id=6b414c28&scoped=true&"
import script from "./VoiceMails.vue?vue&type=script&lang=ts&"
export * from "./VoiceMails.vue?vue&type=script&lang=ts&"
import style0 from "./VoiceMails.vue?vue&type=style&index=0&id=6b414c28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b414c28",
  null
  
)

export default component.exports